import { useState } from "react";
import { chevronDownIcon } from "../../../assets/icons";

const OPENING_BRACKETS = "{";
const CLOSING_BRACKETS = "}";

const GetJsonView = ({ object, objectName }) => {
  const [shouldShowChildObject, setShouldShowChildObject] = useState(true);

  return (
    <>
      <div>
        <img
          src={chevronDownIcon}
          alt="chevron-down-icon"
          className="inline-block w-6 h-6 pr-0.5 -ml-1 opacity-70 cursor-pointer"
          onClick={() => setShouldShowChildObject(!shouldShowChildObject)}
        />
        {objectName && <span className="pr-1">{objectName}:</span>}
        {OPENING_BRACKETS}
      </div>
      {shouldShowChildObject && (
        <div className="ml-0.5 pl-4 border-l border-gray-700">
          {Object.keys(object).map((key) => {
            const value = object[key];
            const isObjectTypeValue = value instanceof Object;

            return (
              <div key={key}>
                {isObjectTypeValue && (
                  <GetJsonView object={value} objectName={key} />
                )}
                {!isObjectTypeValue && (
                  <>
                    <span className="pr-1 font-normal text-blue-300">{key}:</span>
                    <div className="text-orange-400 inline-block break-words">
                      {value}
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      )}
      <div>{CLOSING_BRACKETS}</div>
    </>
  );
};

export default GetJsonView;
